const tradeIn = () => {
    let submitted = false;

    const selectors = {
        form: '[data-trade-in-form]',
        submitButton: '[data-trade-in-form] [data-submit]',
        errorBox: '[data-trade-in-form] [data-error-message]',
    };

    const modal = document.querySelector('[data-trade-in-modal]');
    const widget = document.querySelector('[data-trade-in-widget]');
    // const widgetCount = widget.querySelector('[data-trade-in-widget-count]');
    const widgetTotal = widget.querySelector('[data-trade-in-widget-total]');

    const storageManger = {
        get() {
            const info = document.cookie.match('(^|;) ?basket-trade-in=([^;]*)(;|$)');
            if (info && info[2]) {
                try {
                    return JSON.parse(atob(info[2]));
                } catch (e) {
                    return {};
                }
            }
            return {};
        },
    };

    const submitHandler = function(e) {
        e.preventDefault();

        if (submitted) {
            return;
        }

        disableButton(true);
        displayFormError();

        let isResponseOk = true;
        const form = document.querySelector(selectors.form);
        const formData = new FormData(form);

        fetch(form.action, {
            method: form.method,
            body: formData,
            headers: new Headers({
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            }),
        }).then(function(response) {
            isResponseOk = response.ok;
            return response.json();
        }).then(function(data) {
            if (!isResponseOk) {
                return Promise.reject(data);
            }
            onSuccessHandler(data);
        }).catch(function(err) {
            displayFormError(err);
        }).finally(function() {
            disableButton(false);
        });
    };

    const disableButton = function(state) {
        submitted = state;
        document.querySelector(selectors.submitButton).toggleAttribute('disabled', state);
    };

    const onSuccessHandler = function(data) {
        updateWidget(data);
        $(modal).modal('hide');
    };

    const displayFormError = function(error) {
        document.querySelector(selectors.form).classList.toggle('has-error', !!error);
        document.querySelector(selectors.errorBox).innerText = error ? error.message : '';
    };

    const updateWidget = function(data) {
        widget.classList.toggle('has-trade-in', !!data.count);
        if (data.count) {
            // widgetCount.innerText = data.count;
            widgetTotal.innerText = '£' + data.amount.toFixed(2);
        }
    };

    window.addEventListener('basket:trade-in:product-loaded', function() {
        document.querySelector(selectors.submitButton).addEventListener('click', submitHandler);
    });

    window.addEventListener('DOMContentLoaded', function() {
        const data = storageManger.get();
        updateWidget(data);
    });
};

export default tradeIn;
